import { createContext, useContext } from 'react'

export type Attachment = { id: string; file: File }

export type FeedbackFormData = {
  message: string
  files: Attachment[]
  facilityId: number | null
}

type FeedbackDialogContextValue = FeedbackFormData & {
  setFormData: (formData: Partial<FeedbackFormData>) => void
  addFiles: (files: File[]) => void
  deleteFile: (id: string) => void
  resetFormData: () => void
}

export const FeedbackDialogContext = createContext<FeedbackDialogContextValue | null>(null)

export const useFeedbackDialogContext = () => {
  const context = useContext(FeedbackDialogContext)
  if (!context) throw new Error('FeedbackDialogContext must be used within provider.')
  return context
}
